var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprisePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    transform: "translate(0 -0.474)",
    fill: "#8f6aea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.918,6.72V4.5H3.375v9.993H14.2V6.72ZM5.592,13.382H4.484V12.271H5.592Zm0-2.22H4.484V10.051H5.592Zm0-2.22H4.484V7.831H5.592Zm0-2.222H4.484V5.609H5.592Zm2.217,6.662H6.7V12.271H7.809Zm0-2.22H6.7V10.051H7.809Zm0-2.22H6.7V7.831H7.809Zm0-2.222H6.7V5.609H7.809Zm5.283,6.662H8.918V12.271h1.109V11.162H8.918V10.051h1.109V8.94H8.918V7.831h4.174Zm-.978-4.44H11.005v1.111h1.109Zm0,2.22H11.005v1.111h1.109Z",
    transform: "translate(1.712 1.003)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlan);
export default __webpack_public_path__ + "static/media/enterprise_plan.a6e4a5ba85b1accd40dbc45576b5dbfc.svg";
export { ForwardRef as ReactComponent };